import { Switch } from '@material-ui/core/'
import { em, rem } from 'polished'
import styled from 'styled-components'

import { type ILabelledToggleProps } from '../LabelledToggle'
export const LabelledToggleStyled = styled((props: ILabelledToggleProps) => {
  const { noColor, yesColor, ...otherProps } = props
  return (
    <Switch
      {...otherProps}
      role='switch'
      aria-checked={props.checked ? 'true' : 'false'}
      classes={{
        track: 'toggleBar',
        checked: 'toggleChecked',
        disabled: 'toggleDisabled',
        thumb: 'toggleIcon',
        switchBase: 'toggleIconBase',
      }}
      disableRipple={true}
    />
  )
})`
  font-size: ${rem(16)};
  width: auto !important;
  height: auto !important;

  && {
    overflow: visible;
    padding: 0;
  }

  .MuiSwitch-input {
    left: 0;
    width: 100%;
  }

  .toggleIconBase {
    display: block;
    width: 100%;
    height: 100%;
    font-size: ${em(12)};
    padding: 0;

    > span {
      display: block;
      width: 100%;
      height: 100%;
      position: relative;
    }

    &:hover {
      background-color: transparent;
    }

    + .toggleBar {
      background-color: ${(props) => props.theme.colors.lightGrey};
      display: flex;
      border-radius: 3em;

      &:before {
        content: '${(props) => props.no}';
      }

      &:after {
        content: '${(props) => props.yes}';
      }

      &:before,
      &:after {
        display: block;
        padding: 0.5rem 1rem;
        font-size: ${em(12)};
        font-weight: ${(props) => `${props.theme.fontWeights.semibold}`};
        white-space: nowrap;
      }
    }

    .toggleIcon {
      width: auto;
      height: auto;
      background-color: ${(props) => props.theme.colors[props.noColor]};
      padding: 0.5rem 1rem;
      border-radius: 3em;
      position: absolute;
      top: 0;
      left: 0;
      transition:
        transform 0.2s ease-out,
        background-color 0.2s ease-out,
        left 0.2s ease-out;
      box-shadow: ${(props) => props.theme.shadows[1]};

      &:before {
        content: '${(props) => props.no}';
        display: block;
        width: auto;
        color: ${(props) => props.theme.colors.text.inverse};
        white-space: nowrap;
        font-weight: ${(props) => `${props.theme.fontWeights.semibold}`};
      }
    }

    &.toggleChecked {
      transform: none;

      &:hover {
        background-color: transparent;
      }

      + .toggleBar {
        background-color: ${(props) => props.theme.colors.lightGrey};
      }

      .toggleIcon {
        transform: translateX(-100%);
        left: 100%;
        background: ${(props) => props.theme.colors[props.yesColor]};

        &:before {
          content: '${(props) => props.yes}';
        }
      }
    }

    &.toggleDisabled {
      + .toggleBar {
        background-color: ${(props) => props.theme.colors.lightGrey};
        opacity: 0.25;
      }

      .toggleIcon {
        background: ${(props) => props.theme.colors.disabled};
        box-shadow: none;
      }
    }
  }
`
